import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './LocationsFilter.module.css';
import { getRgbFromColorName, importantPlaceIcons, truncateText } from 'shared/utility';

const locationsFilter = (props) => {
  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);

  const selectAll = () => {
    const locationNames = props.importantPlaces.map((importantPlace) => importantPlace.Location2);
    props.select(locationNames, 'locations', true);
  };

  const selectLocation = (locationName) => {
    props.select([locationName], 'locations');
  };

  const importantPlacesList = props.importantPlaces.map((importantPlace) => {
    const locationIcon =
      importantPlace.LocIcon && importantPlaceIcons.filter((icon) => icon.name === importantPlace.LocIcon).length > 0
        ? importantPlaceIcons.filter((icon) => icon.name === importantPlace.LocIcon)[0]
        : null;
    const listItemClasses = [classes.ListItem];
    if (props.locations.includes(importantPlace.Location2)) listItemClasses.push(classes.Selected);
    return (
      <div className={listItemClasses.join(' ')} key={importantPlace.Id} onClick={() => selectLocation(importantPlace.Location2)}>
        {props.locations.includes(importantPlace.Location2) ? (
          <FontAwesomeIcon icon="check" className={classes.CheckMark} />
        ) : (
          <locationIcon.image alt={locationIcon.name} fillColor={getRgbFromColorName(props.postingAs.Color)} type="LogsFilter" />
        )}
        <div className={classes.Location}>
          <h3>{truncateText(importantPlace.Location, 34)}</h3>
          <p>{truncateText(importantPlace.Location2, 49)}</p>
        </div>
      </div>
    );
  });

  return (
    <div className={containerClasses.join(' ')}>
      <div
        onClick={props.toggleLocationOnly}
        className={props.locationsOnly ? [classes.LocationsOnly, classes.Selected].join(' ') : classes.LocationsOnly}
      >
        <FontAwesomeIcon icon="check" className={classes.CheckMark} />
        <h3>Only show posts with locations</h3>
      </div>
      <div className={classes.ImportantPlacesList}>
        <h3 className={classes.Title}>Only show posts with these Important Places</h3>
        <div className={classes.List}>{importantPlacesList}</div>
      </div>
      <div className={classes.Controls}>
        <div className={classes.SelectOptions}>
          <p onClick={selectAll}>Select All</p>
          <p onClick={props.clear}>Clear</p>
        </div>
        <p onClick={props.submit}>SAVE</p>
      </div>
    </div>
  );
};

export default locationsFilter;
